<template>
  <div>
    <div class="content-show" v-if="workData">
      <div id="fixed-content">
        <div>
          <div
            id="background-1"
            v-bind:style="{
              opacity: 1,
              background:
                'linear-gradient(20deg,rgb(198, 135, 255),rgb(11, 168, 223))',
            }"
          ></div>
        </div>
        <div>
          <NavBar currentPage="work" navClass="nav-work" />
        </div>
      </div>
      <div>
        <div id="page-content">
          <div id="page-scroll-helper"></div>
          <div id="work-scroll-wrapper">
            <div class="vertical-line vertical-line-left"></div>
            <div class="vertical-line vertical-line-right"></div>
            <div id="mywork">
              <div class="work-title-container col">
                <div class="horizontal-line-work horizontal-line"></div>
                <div class="work-title">
                  <h2 class="font-title">{{ workData.title }}</h2>
                </div>
                <div class="horizontal-line-work horizontal-line"></div>
              </div>
              <ul class="work-content">
                <li
                  v-for="(project, index) in workData.projects"
                  :key="index"
                  class="project"
                  :class="{
                    'project-struct-right': index % 2 === 0,
                    'project-struct-left': index % 2 !== 0,
                  }"
                  v-scrollanimation
                >
                  <div
                    class="project-content"
                    :class="{ 'project-content-reverse': index % 2 === 0 }"
                  >
                    <p class="project-overline font-focus">{{workData.projectsHeader}}</p>
                    <h3 class="project-title font-title">
                      {{ project.title }}
                    </h3>
                    <div class="project-description">
                      <p>
                        {{ project.description }}
                      </p>
                    </div>
                    <ul class="project-tech-list">
                      <li
                        v-for="tech in project.technologies"
                        :key="tech"
                        class="font-focus"
                      >
                        {{ tech }}
                      </li>
                    </ul>
                  </div>
                  <div class="project-image">
                    <div class="project-image-overlay"></div>
                    <img :src="project.image" :alt="project.title" />
                  </div>
                </li>
              </ul>
              <div class="copyright center-content">
                <span> Designed and coded by Santiago Rodriguez <span class="copy-symbol">©</span> 2022</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import NavBar from './NavBar.vue';

const workData = ref(null);

onMounted(async () => {
  const response = await fetch('/data/work-data.json');
  workData.value = await response.json();
});
</script>

<style scoped>
.project-struct-left.before-enter {
  transform: translateX(500px);
}

.project-struct-right.before-enter {
  transform: translateX(-500px);
}

.before-enter {
  opacity: 0;
  transition: all 2s cubic-bezier(0.68, 0.57, 0.01, 1.13);
  transition-delay: 0.5s;
}

.enter {
  opacity: 1 !important;
  transform: translateX(0px) !important;
}

@media (max-width: 450px) {
  .project-struct-left.before-enter {
    transform: translateX(300px);
  }

  .project-struct-right.before-enter {
    transform: translateX(-300px);
  }
}
</style>

<style src="../css/general-style.css"></style>
<style src="../css/workStyle.css"></style>